import React from 'react';
import { connect } from 'react-redux';
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import WebViewerFeaturePackagesTable from '../components/webViewerFeaturePackagesTable';
import OverlayLoader from '../components/overlayLoader';
import * as webViewerFeaturePackagesActions from '../store/webViewerFeaturePackagesSlice';
import { webViewerFeaturePackagesSelectors } from '../store/webViewerFeaturePackagesSlice';
import './common.css';
import setTitleToFilters from '../common/filtersTitles';

class WebViewerFeaturePackagesContainer extends React.Component {
  componentDidMount() {
    setTitleToFilters();
    this.props.fetchAllWebViewerFeaturePackages();
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>Web viewer feature packages</h1>
          {this.renderButtons()}
          {this.renderContent()}
        </div>
      </OverlayLoader>
    );
  }

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement
        type="button"
        text="Refresh"
        icon="refresh"
        onClick={this.props.fetchAllWebViewerFeaturePackages}
      />
    </TooltipButtonGroup>
  );

  renderContent = () => {
    if (this.props.webViewerFeaturePackagesFetchingError)
      return this.renderError(this.props.webViewerFeaturePackagesFetchingError.toString());
    return (
      <React.Fragment>
        <WebViewerFeaturePackagesTable
        webViewerFeaturePackages={this.props.webViewerFeaturePackages}
        />
      </React.Fragment>
    );
  };

  renderError = (message) => <p className="text-danger">Error: {message}</p>;

  isLoading = () => this.props.isWebViewerFeaturePackagesFetching;

  getLoaderMessage = () => {
    if (this.props.isWebViewerFeaturePackagesFetching)
      return 'Web viewer feature packages loading...';
  };
}

const mapStateToProps = (state) => ({
  isWebViewerFeaturePackagesFetching: webViewerFeaturePackagesSelectors.isFetching(state),
  webViewerFeaturePackages: webViewerFeaturePackagesSelectors.selectAll(state),
  webViewerFeaturePackagesFetchingError: webViewerFeaturePackagesSelectors.fetchingError(state),
});

const actionCreators = {
  fetchAllWebViewerFeaturePackages: webViewerFeaturePackagesActions.fetchAllWebViewerFeaturePackages,
};

export default connect(mapStateToProps, actionCreators)(WebViewerFeaturePackagesContainer);


// WEBPACK FOOTER //
// ./src/containers/webViewerFeaturePackagesContainer.js